import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgCheck(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.707 6.293a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L10 14.586l8.293-8.293a1 1 0 0 1 1.414 0Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgCheck)
